<script lang="ts" setup>
import Card3 from '@/components/Card/Card3.vue'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import type { IEvent } from '@/utils/types'

const props = defineProps({
  events: {
    type: Array as PropType<IEvent[]>,
    default: () => []
  }
})
SwiperCore.use([Autoplay, Pagination])



// swiper
const swiperSlideSelector = ref()
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data
}

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index)
}

const handlePaginationChange = (index: number) => {
  swiperTo(index)
}
</script>

<template>
  <section class="brandBox">
    <div class="brandBox__top" data-aos="fade-up" data-aos-duration="1500">
      <div class="brandBox__top__enTitle">events</div>
      <div class="brandBox__top__twTitle">品牌活動</div>
    </div>
    <div class="brand-event">
      <ul class="events__list">
        <li v-for="item in events" :key="item.id">
          <Card3 :item="item" />
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.brand-event {
  grid-column: 1/span 12;
}

.brandBox {
  margin-bottom: toRem(180);
  display: grid;
  flex-direction: column;
  align-items: flex-start;
  gap: toRem(88);

  @include max-media(990) {
    gap: toRem(32);
  }

  &__top {
    position: relative;
    z-index: 1;
    // margin-bottom: toRem(50);

    &__enTitle {
      line-height: 1.2;
      font-family: $font-TextaAlt;
      color: $color-gray-3;
      // font-size: toRem(80);
      font-size: 5.5vw;
      font-weight: 500;
      letter-spacing: toRem(-1.6);

      @include max-media(990) {
        font-size: toRem(80);
      }
    }

    &__twTitle {
      line-height: 1;
      color: $color-black-1;
      // font-size: toRem(28);
      font-size: 2vw;
      font-weight: 500;

      @include max-media(990) {
        font-size: toRem(28);
      }
    }
  }
}

.events {
  &__list {
    display: grid;
    column-gap: toRem(24);
    grid-template-columns: repeat(auto-fill, calc((100% - 24px) / 2));

    @include max-media(990) {
      grid-template-columns: repeat(auto-fill, 100%);
    }

    li {
      margin-bottom: toRem(84);

      @include max-media(990) {
        margin-bottom: toRem(32);
      }
    }
  }
}
</style>
